pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.boards_slider = {

	//default: $(

	init: function(){

			//console.log('board sliders is always happening..?');

			let html = '';

				$.ajax({

					url: endpoint+'/surfboardmodels',
					method: 'get'

				}).done( r => {

					$.each( r, ( k, i ) =>{					      					

						html += 

						`<a href="?page=surfboard-details&id=${ i.id_surfboardmodel }" class="slide surfboard-listing-single">

							<div class="name">

								${ i.surfboardmodel }

							</div>
							
							<div class="price">

								${ i.min_price } EUR

							</div>
							
							<!-- make images adaptive -->
							<img src="${ i.img_dynamic }??w=340&h=553&fit=crop" srcset="${ i.img_dynamic }?w=340&h=553&fit=crop 1200w" alt="${ i.surfboardmodel }" width="340" height="425">

							<div class="category">

								${ i.surfboardmodeltype }

							</div>
							
							<div class="specs">

								${ i.wavesize.min }-${ i.wavesize.max}${ i.wavesize.measure } /

								${ 

									pyzel.helpers.skill_level( i.skilllevel )

								}

							</div>

							<div class="btn btn-primary btn-sm">See more</div>

						</a>`;

					})

					$('#js-homepage-boards-slider').html( html );

					pyzel.sliders.homepageBoards();	

				})


		}

	//)

}